/*****************************************************************************
*
* MCAFEE CONFIDENTIAL
* Copyright (c)2019 McAfee, LLC
*
* The source code contained or described herein and all documents related
* to the source code ("Material") are owned by McAfee or its
* suppliers or licensors. Title to the Material remains with McAfee
* or its suppliers and licensors. The Material contains trade
* secrets and proprietary and confidential information of McAfee or its
* suppliers and licensors. The Material is protected by worldwide copyright
* and trade secret laws and treaty provisions. No part of the Material may
* be used, copied, reproduced, modified, published, uploaded, posted,
* transmitted, distributed, or disclosed in any way without McAfee's prior
* express written permission.
*
* No license under any patent, copyright, trade secret or other intellectual
* property right is granted to or conferred upon you by disclosure or
* delivery of the Materials, either expressly, by implication, inducement,
* estoppel or otherwise. Any license under such intellectual property rights
* must be expressed and approved by McAfee in writing.
*
****************************************************************************/

/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

import { globalEngine, ModuleManager } from "./Init"
import { logNormal, logInformation, logWarning, logError, logDebug, logConsole, logRawTrack, logTransports, logAutomationError } from "./bootstrap_web_ext";

// #ENDIF WebPack
    function TransportPlugin_Template()
    {
    };
    
    if (typeof TransportPlugin_Template.prototype.GetName !== 'function')
    {
        TransportPlugin_Template.prototype =
        {
            // This object needs to look and behave like any of the C++ transport plugins (e.g. CSPPlugin)
            //   The public interface MUST have at least the following (based on how transport.js is calling it):
            //     GetName()
            //          return the name provided in Initialize
            //     GetVersion() 
            //          won't be entirely relevant but we will return the version of the underlying REST plugin.
            //     Initialze(name, string(transport-dictionary), string(transport-config))
            //          where name is duh, 
            //                transport-dictionary == stringified datamodel->target map, 
            //                transport-config == stringified profile data from transport_config.js
            //     Send(string(data))
            //          where data is the analytics record data in stringified-dictionary form (DataModel keys)
            //     Uninitialize()
            //          informs the plugin that all work is complete so that it can cleanup internals.
            "GetName": function () {
                return this._name;
            },
            "GetVersion": function () {
                if (transport_template_fileVersion)
                {
                    return transport_template_fileVersion;
                }
                return '0.0.0';
            },
            "Initialize": function (name, dictionary, config)
            {
                try
                {
                    // NOTE; because this mirrors the C++ plugins, 'dictionary' and 'config' are stringified objects, so ...
                    if (!config || !name || !dictionary)
                    {
                        logError('TransportPlugin_Template: Failed to initialize (' + 'name' + '). Config: ' + config + '. Name: ' + name + '.Dictionary: ' + dictionary);
                        return false;
                    }
    
                    this._dictionary = JSON.parse(dictionary); //Can be an empty object
                    this._config = JSON.parse(config);
                    this._name = name;
    
                    if (!this._config || !this._name)
                    {
                        logError('TransportPlugin_Template: Failed to initialize (' + 'name' + '). Config: ' + config + '. Name: ' + name);
                        return false;
                    }
                  
                    return this._setup();
                }
                catch (e)
                {
                    logError('TransportPlugin_Template::Initialize Exception caught with message: ' + e.message);
                }
            },
            "Send": function (eventDataString) {
    
                //This function needs to be overwrriten by the corresponding child
                logError('TransportPlugin_Template::Send: Did not overwrite function. Send will return false');
                return false;
            },
            "Uninitialize": function () {
                this._dictionary = null;
                this._config = null;
                this._name = null;
            },
            "_setup": function()
            {
                logError('TransportPlugin_Template::_setup: Did not overwrite function. _setup will return false');
                return false;
            },
            "_dictionary": {},
            "_config": {},
            "_name": null,
            "_verb": null
        }
    }
    
ModuleManager.registerFactory("transport_template", TransportPlugin_Template);
//export {TransportPlugin_Template};
//globalEngine.FactoryMap["transport_template"] =  TransportPlugin_Template;
